import Vue from 'vue';
import Vuex from 'vuex';

import Classification from './modules/Classification';
import ProductType from './modules/ProductType';
import Supplier from './modules/Supplier';
import Product from './modules/Product';
import Customer from './modules/Customer';
import RawMaterial from './modules/RawMaterial';
import Sale from './modules/Sale';
import Unit from './modules/Unit';
import GoldClassification from './modules/GoldClassification';
import Karat from './modules/Karat';
import Rush from './modules/Rush';
import Category from './modules/Category';
import JobOrder from './modules/JobOrder';
import Set from './modules/Set';
import User from './modules/User';
import UserPermission from './modules/UserPermission';
import Permission from './modules/Permission';
import Dashboard from './modules/Dashboard';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Classification,
    ProductType,
    Supplier,
    Product,
    Customer,
    RawMaterial,
    Sale,
    Unit,
    GoldClassification,
    Karat,
    Rush,
    Category,
    JobOrder,
    Set,
    User,
    UserPermission,
    Permission,
    Dashboard
  },
  state: {
    token: localStorage.getItem('user-token') || '',
    layout: 'app-layout',
    snackBarMessage: '',
    loading: false,
    barcodes: [],
    showbarcode: false,
    dashboardRefesh: {},
    lastAction: undefined
  },
  getters: {
    isAuthenticated: state => !!state.token,
    layout: state => state.layout
  },
  actions: {
    openBarCodePrint({ commit }) {
      commit('SET_BARCODE_PRINT', true);
    },
    closeBarCodePrint({ commit }) {
      commit('SET_BARCODE_PRINT', false);
      commit('SET_BARCODES', []);
    },
    setBarcodes({ commit }, payload) {
      commit('SET_BARCODES', payload);
    },
    setDashboardRefresh({ commit, state }, payload) {
      clearTimeout(state.dashboardRefesh);
      commit('SET_DASHBOARD_REFRESH', payload);
    },
    clearDashboardRefresh({ commit, state }) {
      clearTimeout(state.dashboardRefesh);
      commit('SET_DASHBOARD_REFRESH', {});
    }
  },
  mutations: {
    SET_LAST_ACTION(state, payload) {
      state.lastAction = payload;
    },
    SET_DASHBOARD_REFRESH(state, payload) {
      state.dashboardRefesh = payload;
    },
    SET_BARCODES(state, payload) {
      state.barcodes = payload;
    },
    SET_BARCODE_PRINT(state, payload) {
      state.showbarcode = payload;
    },
    AUTH_SUCCESS(state, token) {
      state.token = token;
      localStorage.setItem('user-token', token);
      window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    CLOSE_SNACK_BAR(state, payload) {
      state.snackBar = false;
    },
    SET_SNACK_BAR(state, payload) {
      state.snackBarMessage = payload.message;
      state.snackBarColor = payload.color;
    },
    SET_LAYOUT(state, payload) {
      state.layout = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    logout(state) {
      state.token = undefined;
      localStorage.removeItem('user-token');
      delete window.axios.defaults.headers.common['Authorization'];
    }
  }
});
